export default {
  ht: {
    common:{
      search: '查询',
      reset: '重置',
      save: '保存',
      cancle: '取消',
      up: '上移',
      down: '下移',
      remove: '删除',
      clear: '清空',
      index: '序号',
      selected: '已选择'
    },
    tree:{
      filterText: '输入关键字进行过滤'
    },
    selectLang:{
      switchLang: '切换语言'
    },
    file: {
      nopreview: '没有预览权限'
    }
  }
};